import { Component } from '@angular/core';
import noAccessText from '../../constants/no-access-text.json';

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.sass']
})
export class NoAccessComponent {
  txt = noAccessText;

  onNavigateHome = (): void => {
    window.location.href = this.txt.homeLink;
  };
}
